export default __webpack_public_path__ + "static/media/home-logo.62b1a1f4.png";